import { type QueryParamsHandling } from '@angular/router';
import { type UserConfigType } from '@tig-dpqa-cloud/contract-backend-frontend';
import { createInjectable } from 'ngxtension/create-injectable';

export type NavigationRoute = {
  name: string;
  icon: string;
  link: string;
  priority: number;
  requiredPermissions: UserConfigType['permissions'];
  queryParamHandling?: QueryParamsHandling;
};

export const navigationRoutes: NavigationRoute[] = [
  {
    name: 'NAVIGATION.DASHBOARD',
    icon: 'grid',
    link: '/dashboard',
    requiredPermissions: ['DASHBOARD_READ'],
    priority: 1,
  },
  {
    name: 'NAVIGATION.SLIDES',
    icon: 'slides',
    link: '/slides',
    requiredPermissions: ['SLIDE_SCANS_READ'],
    queryParamHandling: 'preserve',
    priority: 0,
  },
  {
    name: 'NAVIGATION.SETUP',
    icon: 'settings-2',
    link: '/setup',
    requiredPermissions: ['SETUP_READ'],
    priority: 1,
  },
  {
    name: 'NAVIGATION.USER_MANAGEMENT',
    icon: 'users',
    link: '/user-management',
    requiredPermissions: ['USER_MANAGEMENT_WRITE'],
    priority: 1,
  },
];

export const NavigationService = createInjectable(

  () => {
    const firstAllowedRoute = (userPermissions: string[]): NavigationRoute | undefined => {
      if (userPermissions?.length === 0) {
        return undefined;
      }
      return navigationRoutes
        .slice()
        .sort((a, b) => a.priority - b.priority)
        .find(
          (route) => route.requiredPermissions.every((p) => userPermissions.includes(p)),
        ) || undefined;
    };

    return { firstAllowedRoute };
  },
  { providedIn: 'root' },
);
